import * as React from "react";
import { Col, Container, Row } from "react-grid-system";
import { AiOutlineReload } from "react-icons/ai";
import styled from "styled-components";

import { StyledColor } from "../../interface/index";
import colors from "../../assets/colors/colors";
import { API } from "../../utils/config";

import ModalEditBusiness from "../../components/super/ModalEditBusiness";
import TableBusiness from "../../components/super/TableBusiness";
import TableUsers from "../../components/super/TableUsers";
import Header from "../../components/layout/Header";
import Loader from "../../components/utils/Loader";
import { GetTodosRestaurants_API, GetUsersyRestaurant } from "../../API";
import Table from "../../components/utils/Table.js";

export default function Dashboard() {
  const [loader, setLoader] = React.useState(false);
  const [admin, setAdmin] = React.useState<boolean>(false);

  const [user_comlete, setUserComplete] = React.useState<any>(null);

  // modal edit user
  const [datamodaledit, setDataModalEdit] = React.useState<any>(null);
  const [modaledituser, setModalEditUser] = React.useState<boolean>(false);

  const [totals, setTotals] = React.useState<any>({
    users_premiums: null,
    users_registers: null,
    users_no_premium: null,
  });

  React.useEffect(() => {
    getData();
  }, []);

  const getData = async () => {
    setLoader(true);
    const id = localStorage.getItem("localId");
    const token = localStorage.getItem("token");

    if (id) {
      try {
        const route = "restaurant?restaurant_id";

        const response = await API.get(`${route}=${id}`);
        const response2 = await GetUsersyRestaurant(token);

        const data = response2.data.data;

        setUserComplete(data);
        getTotals(data);

        setLoader(false);

        if (!response.data.data.superadmin) {
          localStorage.clear();
          window.location.reload();
        } else {
          setAdmin(true);
        }
      } catch (error) {
        setLoader(false);
        alert("Menu no encontrado🙊");
      }
    }
  };

  const getTotals = (data: any) => {
    let users_premiums: any = [];
    let users_no_premiums: any = [];
    let users_registers: any = [];

    data.map((dt: any) => {
      users_registers.push(dt);
      if (dt.premium) {
        users_premiums.push(dt);
      } else {
        users_no_premiums.push(dt);
      }
    });

    setTotals({
      users_premiums: users_premiums,
      users_no_premiums: users_no_premiums,
      users_registers: users_registers,
    });
  };

  const openEditRestaurant = (data: any) => {
    setDataModalEdit(data);

    let open = !modaledituser;
    setModalEditUser(open);
  };

  return (
    <>
      <Header />
      {admin && (
        <>
          <Content color={colors}>
            <Container>
              <h3 className="my-4">Dashboard Administrativo</h3>

              <main>
                {!loader && (
                  <section>
                    <Row align="center" justify="center">
                      <Col md={3}>
                        <div className="card border-primary p-4 text-center">
                          <h2>
                            <span> {totals.users_registers.length} </span>
                          </h2>
                          <h5>Usuarios registrados</h5>
                        </div>
                      </Col>
                      <Col md={3}>
                        <div className="card border-primary p-4 text-center">
                          <h2>
                            <span> {totals.users_premiums.length} </span>
                          </h2>
                          <h5>Usuarios Premiums</h5>
                        </div>
                      </Col>
                      <Col md={3}>
                        <div className="card border-primary p-4 text-center">
                          <h2>
                            <span> {totals.users_no_premiums.length} </span>
                          </h2>
                          <h5>Usuarios No Premiums</h5>
                        </div>
                      </Col>
                    </Row>
                  </section>
                )}
                <section className="my-4">
                  <Row className="mb-2 mt-4">
                    <Col>
                      <h4>Negocios</h4>
                    </Col>
                    <Col xs={2}>
                      <button
                        className="btn btn-primary"
                        onClick={() => getData()}
                      >
                        <AiOutlineReload />
                      </button>
                    </Col>
                  </Row>

                  {!loader && (
                    <>
                      {user_comlete && (
                        <Table
                          theadTable={[
                            "name",
                            "id",
                            "email",
                            "phone",
                            "premium",
                          ]}
                          data={user_comlete}
                          openEditRestaurant={openEditRestaurant}
                        />
                      )}
                    </>
                  )}
                </section>
                {loader && (
                  <div className="w-100 text-center">
                    <Loader color="#3498db" />
                  </div>
                )}
              </main>
            </Container>
          </Content>
          {modaledituser && (
            <ModalEditBusiness
              openEditRestaurant={openEditRestaurant}
              data={datamodaledit}
              getData={getData}
            />
          )}
        </>
      )}
    </>
  );
}

const Content = styled.div<StyledColor>`
  min-height: 100vh;
`;
